import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { CorrelationType } from '@app/core/enums/correlation-type.enum';
import { CommonStateStatus } from '@app/core/enums/common-state-status.enum';
import dayjs from 'dayjs';
import { coordinateSystemForProject } from '@mock/data/coordinate-systems-mock.data';
import { testProjectId } from '@mock/data/projects-mock.data';
import { soundSignalTime2 } from '@mock/data/logger-measurements-mock.data';

const testProjectCoordinateSystemId = coordinateSystemForProject(testProjectId).id;

export const correlationsMockData: ICorrelation[] = [
  {
    id: 'correlation1',
    quality: 55,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.Pinpoint,
    suppressed: true,
    logger1DeploymentId: 'ld00001',
    logger2DeploymentId: 'ld00005',
    soundSignalStartAt: soundSignalTime2,
    distanceL1: 569,
    distanceL2: 782,
    centerDistance: 459,
    pipeLength: 1863,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 43351.5074,
      axis2: -7565.1278,
    },
    coordinates: {
      lat: 15.17679660042541,
      lon: 145.7734311259112,
    },
    comment: {
      content: '_some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-10').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
    consistency: 0.87,
    maxTime: 1.23,
    maximum: 0.95,
    soundVelocity: 1420,
    overlap: 0.75,
    corrLength: 4.5,
    delayMax: 0.003,
    whyUnsynchronized: 'Signal too weak',
  },
  {
    id: 'correlation2',
    quality: 87,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.Pinpoint,
    suppressed: false,
    logger1DeploymentId: 'ld00007',
    logger2DeploymentId: 'ld00015',
    soundSignalStartAt: soundSignalTime2,
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: true,
    coordinates: {
      lat: 15.17709362292977,
      lon: 145.7751273451446,
    },
    comment: {
      content: `his is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.
This is exactly what you want when you want to make sure things never leak. The wall thickness is flawless, and the smooth interior keeps everything flowing without building up scale.`,
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: null,
  },
  {
    id: 'correlation3',
    quality: 97,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.Pinpoint,
    suppressed: false,
    logger1DeploymentId: 'ld00013',
    logger2DeploymentId: 'ld00005',
    soundSignalStartAt: soundSignalTime2,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -65.1278,
    },
    coordinates: {
      lat: 15.17829188210032,
      lon: 145.7725719928463,
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation4',
    quality: 78,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.WithoutPipe,
    suppressed: false,
    logger1DeploymentId: 'ld00001',
    logger2DeploymentId: 'ld00014',
    soundSignalStartAt: soundSignalTime2,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: true,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17556304952148,
      lon: 145.7740559835376,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation5',
    quality: 76,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.Unsynced,
    suppressed: false,
    logger1DeploymentId: 'ld00016',
    logger2DeploymentId: 'ld00017',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 50.61096657657072,
      lon: -1.974083341544731,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation6',
    quality: 78,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.Unsynced,
    suppressed: false,
    logger1DeploymentId: 'ld00008',
    logger2DeploymentId: 'ld00011',
    soundSignalStartAt: soundSignalTime2,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17616304952148,
      lon: 145.7760559835376,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  // correlations for displaying different types and statuses
  {
    id: 'correlation1test',
    quality: 81,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.Pinpoint,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17212285492426,
      lon: 145.7784459047284,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation2test',
    quality: 43,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.Pinpoint,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: true,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17212338550107,
      lon: 145.7790124806775,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation3test',
    quality: 2,
    qualityStatus: CommonStateStatus.Normal,
    correlationType: CorrelationType.Pinpoint,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17212414570476,
      lon: 145.7798269271275,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation4test',
    quality: 94,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.WithoutPipe,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17035898274414,
      lon: 145.7773779010878,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation5test',
    quality: 55,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.WithoutPipe,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17044085418784,
      lon: 145.7782469856301,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation6test',
    quality: 100,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.OutOfBracket,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17048496176491,
      lon: 145.7787152128047,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation7test',
    quality: 50,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.OutOfBracket,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17059309022652,
      lon: 145.7798631025112,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation8test',
    quality: 79,
    qualityStatus: CommonStateStatus.Critical,
    correlationType: CorrelationType.Unsynced,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16961525724311,
      lon: 145.7774379564947,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation9test',
    quality: 36,
    qualityStatus: CommonStateStatus.Warning,
    correlationType: CorrelationType.Unsynced,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16957747504224,
      lon: 145.7783848465849,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation10test',
    quality: 55,
    qualityStatus: CommonStateStatus.Normal,
    correlationType: CorrelationType.WithoutPipe,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17039488841689,
      lon: 145.7777590437795,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation11test',
    quality: 55,
    qualityStatus: CommonStateStatus.Normal,
    correlationType: CorrelationType.OutOfBracket,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17052933445935,
      lon: 145.779186264895,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'correlation12test',
    quality: 55,
    qualityStatus: CommonStateStatus.Normal,
    correlationType: CorrelationType.Unsynced,
    suppressed: false,
    logger1DeploymentId: 'ld00029test',
    logger2DeploymentId: 'ld00030test',
    soundSignalStartAt: dayjs('2025-03-12').add(7, 'hour').toISOString(),
    distanceL1: 567,
    distanceL2: 782,
    centerDistance: 456,
    pipeLength: 1563,
    pipeProvided: false,
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16965072579582,
      lon: 145.7778616090099,
    },
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    averagingInterval: {
      startAt: dayjs('2025-03-11').toISOString(),
      endAt: dayjs('2025-03-12').toISOString(),
    },
  },
].map(c => ({
  ...c,
  consistency: c.consistency ?? 0.87,
  maxTime: c.maxTime ?? 1.23,
  maximum: c.maximum ?? 0.95,
  soundVelocity: c.soundVelocity ?? 1420,
  overlap: c.overlap ?? 0.75,
  corrLength: c.corrLength ?? 4.5,
  delayMax: c.delayMax ?? 0.003,
  whyUnsynchronized: c.whyUnsynchronized ?? (c.correlationType === CorrelationType.Unsynced ? 'Signal too weak' : undefined),
}));
